import React, { Component } from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import { List, OrderedMap } from 'immutable';

import Brand from 'models/brand';

import FrequentLocation from 'components/bookings/frequent-location';
import ShowAll from 'components/bookings/show-all';

const FREQUENT_LOCATIONS_LIMIT = 5;
import VisibilitySensor from 'react-visibility-sensor';
import { pageProps } from 'lib/analytics/page-properties';
import { BUTTON_IMPRESSION, BUTTON_CLICK } from 'lib/analytics/events';

const propTypes = {
  locations: PropTypes.instanceOf(List).isRequired,
  recentBookings: PropTypes.instanceOf(OrderedMap).isRequired,
  brand: PropTypes.instanceOf(Brand),
  app: PropTypes.string.isRequired,
  trackEvent: PropTypes.func.isRequired,
};

const defaultProps = {
  brand: new Brand(),
};

class FrequentLocations extends Component {
  constructor(props) {
    super(props);

    this.state = { expanded: false };
    this.toggleExpansion = this.toggleExpansion.bind(this);
    this.onVisibilityChange = this.onVisibilityChange.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  onVisibilityChange(isVisible) {
    const { trackEvent, app } = this.props;
    if (isVisible) {
      const pageProperties = pageProps({ app });
      trackEvent({
        ...BUTTON_IMPRESSION,
        ...pageProperties,
        name: 'ShowMore',
        position: '0',
      });
    }
  }

  onClick() {
    const { trackEvent, app } = this.props;
    const pageProperties = pageProps({ app });
    trackEvent({
      ...BUTTON_CLICK,
      ...pageProperties,
      name: 'ShowMore',
      position: '0',
    });
  }

  toggleExpansion(e) {
    e.stopPropagation();
    e.preventDefault();

    this.setState({ expanded: !this.state.expanded });
  }

  renderHeader() {
    const { locations } = this.props;

    return (
      <div>
        <h2 className="text-color-dark-slate margin-top-10 margin-bottom-0 text-size-20 text-weight-bold">
          FREQUENT LOCATIONS
          <span className="margin-left-20 text-size-14 text-weight-book">{locations.size} { pluralize('Location', locations.size) }</span>
        </h2>
      </div>
    );
  }

  render() {
    const { locations, recentBookings, brand, app, trackEvent } = this.props;
    if (!locations.size) { return null; }

    const frequentLocations = [];

    let index = 0;
    locations.forEach((location) => {
      if (this.state.expanded || (!this.state.expanded && (index < FREQUENT_LOCATIONS_LIMIT))) {
        frequentLocations.push(
          <FrequentLocation
            key={`fl-${location.id}`}
            location={location}
            recentBooking={location.getRecentBooking(recentBookings)}
            brand={brand}
            app={app}
            trackEvent={trackEvent}
            analyticsPosition={index}
          />,
        );
        index += 1;
        return true;
      }
      return false;
    });


    return (
      <div className="booking-section frequent-locations">
        <a className="nav-offset-anchor" id="frequent-locations" />
        { this.renderHeader() }
        <div className="row mock-table-row header hidden-xs">
          <div className="col-sm-offset-2 col-sm-3 grid-header sm dark">LOCATION ADDRESS</div>
          <div className="col-sm-4 grid-header sm dark">LAST PARKED DATE</div>
          <div className="col-sm-3" />
        </div>
        <div>
          { frequentLocations }
          <VisibilitySensor onChange={v => this.onVisibilityChange(v)} partialVisibility>
            <div onClick={() => this.onClick()}>
              <ShowAll
                text="Frequent Locations"
                onClick={this.toggleExpansion}
                expanded={this.state.expanded}
                count={locations.size}
                limit={FREQUENT_LOCATIONS_LIMIT}
                className="mock-table-row"
              />
            </div>
          </VisibilitySensor>
        </div>
      </div>
    );
  }
}

FrequentLocations.propTypes = propTypes;
FrequentLocations.defaultProps = defaultProps;

export default FrequentLocations;
